module.exports = __webpack_public_path__ + "img/1994_L.785724c0.png";